import { render, staticRenderFns } from "./UploaderComponent.vue?vue&type=template&id=ae0069b8&scoped=true"
import script from "./UploaderComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploaderComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./UploaderComponent.vue?vue&type=style&index=0&id=ae0069b8&lang=scss"
import style1 from "./UploaderComponent.vue?vue&type=style&index=1&id=ae0069b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0069b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae0069b8')) {
      api.createRecord('ae0069b8', component.options)
    } else {
      api.reload('ae0069b8', component.options)
    }
    module.hot.accept("./UploaderComponent.vue?vue&type=template&id=ae0069b8&scoped=true", function () {
      api.rerender('ae0069b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileManager/components/uploaderComponent/UploaderComponent.vue"
export default component.exports